/* eslint-disable */
import gCard from "@/components/g-card/g-card.vue";
import gButton from "@/components/g-button/g-button.vue";
import gForm from "@/components/g-form/g-form.vue";
import gPdf from "@/components/g-pdf/g-pdf.vue";
import axios from "axios";
import { defineComponent } from "vue";
import OrcamentoController from "@/shared/controllers/orcamento/orcamentoController";
import ConsultarOrcamentoPDF from '../ConsultarOrcamento/PDF/ConsultarOrcamentoPDF.vue';

const name = "OrcamentoPendenteInformacao";

export class PhotoService {
  async getImage(OrcamentoSelecionado, images) {
    await axios({
      method: "get",
      url:
        process.env.VUE_APP_WEB_API +
        `Produto/GetImagesByOrcamentoId/${OrcamentoSelecionado}`,
    })
      .then((response) => {
        images = response.data.data;
      })

      .catch(() => {});
    return images;
  }
}

export default defineComponent({
  name,
  components: {
    "g-card": gCard,
    "g-button": gButton,
    "g-form": gForm,
    'g-pdf': gPdf,
    ConsultarOrcamentoPDF
  },

  props: {
    orcamentoId: {
      type: String,
      default: "",
    },
    tituloDetalhes: {
      type: Boolean,
      default: true,
    },
  },

  mounted() {
    if (this.orcamentoId) {
      this.OrcamentoSelecionado = this.orcamentoId;
    } else {
      this.OrcamentoSelecionado = this.$route.params.id;
    }

    this.getComponentes();
    this.getCliente();
    this.InformacoesOrcamentoQuantidadeByOrcamentoId();
    // this.InformacoesOrcamentoComponenteByOrcamentoId();
    this.getTipoFluxoOrcamento();
    this.getLog();
    this.validacao();
    this.observacao();
    this.GetOrcamentoQuantidadeIdeal();
    // this.GetFormaPagamentoOrcamento();
    this.options.push("0");
    this.options.push("1");
  },

  galleriaService: null,
  created() {
    this.galleriaService = new PhotoService();
  },

  updated() {
    if (this.orcamentoId === "") {
      return;
    }
    if (this.orcamentoId) {
      this.OrcamentoSelecionado = this.orcamentoId;
    } else {
      this.OrcamentoSelecionado = this.$route.params.id;
    }

    this.getCliente();
    this.getLogOrcamentoPendenteInformacao();

    this.InformacoesOrcamentoQuantidadeByOrcamentoId();
    // this.InformacoesOrcamentoComponenteByOrcamentoId();
    this.getTipoFluxoOrcamento();
    this.validacao();
    this.observacao();
    this.GetOrcamentoQuantidadeIdeal();
    this.GetFormaPagamentoOrcamento();
    this.options.push("0");
    this.options.push("1");
  },

  data() {
    return {
      pdfvisualizacao: false,
      popupRejeitado: false,
      prazoMaximo: '',
      gramatura: '',
      dataEHora: '',
      porcentagemFinanceira: '',
      formaPagamento: '',
      quantidadePrecoArray: [],
      options: [],
      OrcaQuantidade: [],
      InformacaoOrcamentoComponenteArray: [],
      OrcaQuantidadeDiaCarregamento: [],
      dataDigitacaoFormatadaConsulta: "",
      nomeEmpresa: "",
      tipoFluxoOrcamento: "",
      nomeclienteBaixa: "",
      nomeRepresentante: "",
      statusText: "",
      statusEnum: null,
      statuscor: "",
      cnpj: "",
      codigoUsuario: "",
      incentivoFiscal: "",
      nomeCidade: "",
      nomeContato: "",
      numeroRamal: "",
      numeroSuframa: "",
      numeroTelefone: "",
      razaoSocial: "",
      segmentoFormat: "",
      siglaEstado: "",
      cep: "",
      DescricaoLote: "",
      OrcamentoAmostra: "",
      OrcamentoDescricaoSequencia: "",
      OrcamentoAmostraEspTecnica: "",
      OrcamentoAmostraOutros: "",
      OrcamentoEmbalagemDescOutros: "",
      OrcamentoEmbalagemOutros: "",
      OrcamentoEmbalagemCaixaColetiva: "",
      OrcamentoGeraisFsc: "",
      OrcamentoAmostraDescOutros: "",
      InformacaoObservacao: "",
      OrcamentoGeraisLegislacao: "",
      OrcamentoEmbalagemFilme: "",
      OrcamentoEmbalagemPalete: "",
      OrcamentoCritica1: "",
      OrcamentoCritica2: "",
      OrcamentoCritica3: "",
      OrcamentoCritica4: "",
      OrcamentoCritica5: "",
      freteEnum: "",
      getSequencia: "",
      indicadorDeTipoFrete: "",
      tipoFreteEnum: "",
      informacaoLoteText: "",
      riscoFacaPrototipo: "",
      amostraFortmatada: "",
      dataCarregamentoFormatada: "",
      observacoesQuantidade: "",
      quantidade: "",
      codigoProduto: "",
      codigoSistema: "",
      componentesLista: "",
      componenteTipoTexto: "",
      motivoPerda: "",
      descricaoAcabamentoFrenteTexto: "",
      descricaoAcabamentoVersoTexto: "",
      descricaoCapaExternaTexto: "",
      descricaoCapaInternaTexto: "",
      descricaoMaterialTexto: "",
      descricaoMedidasTexto: "",
      descricaoOndaTexto: "",
      descricaoPapelOndaTexto: "",
      nomeCorFrente: "",
      nomeCorVerso: "",
      nomeProduto: "",
      nomeUnidade: "",
      numeroComponente: "",
      numeroGramaturaCapaExterna: "",
      numeroGramaturaCapaInterna: "",
      numeroGramaturaPapelOnda: "",
      observacoesGerais: "",
      embalagemEspecificaCaixaColetiva: "",
      critica1: "",
      checkGerais: [],
      numeroSolicitacao: '',
      temImagem: false,
      //Imagem
      images: {
        arquivo: "",
        arquivobase64: "",
        files: "",
        id: "",
        produto: "",
      },
      renderiza: false,
      OrcamentoSelecionado: null,
      numeroCelular: 0,
      icms: null,
      piscofins: null,
      ipi: null,
      dataAlteracao: null,
      contemComponentes: false,
      executarvisualizacao: 0,
      observacoesRetorno: null
    };
  },

  methods: {
    imprimir(){
        this.renderiza = true
        this.OrcamentoId = this.$route.params.id
        this.executarvisualizacao++
    },
    gerarPdf(){
    },
    voltar() {
      this.$router.push(`/orcamentos-pendentes`);
    },

    executaTermino() {
      this.$emit("termino");
    },

    entrarPopUp() {
      this.popupRejeitado = true;
    },

    sairPopUp() {
      this.popupRejeitado = false;
    },

    salvarMotivoPerda() {
      let SalvarMotivoPerdaArray = {
        MotivoPerda: this.motivoPerda,
      };

      this.axios({
        method: "post",
        url:
          process.env.VUE_APP_WEB_API +
          `Orcamento/InsertMotivoPerda/${this.$route.params.id}`,
        data: SalvarMotivoPerdaArray,
      })
        .then((response) => {
          this.sairPopUp();
          this.GetResultForm(response);
        })
        .catch(() => {});
    },

    fecharpopupsair() {
      this.popupRejeitado = false;
    },

    validacao() {
      this.validacao;
      if (this.cep == null) {
        this.cep = "N/A";
      }
    },

    getTipoFluxoOrcamento() {
      this.axios({
        method: "get",
        url:
          process.env.VUE_APP_WEB_API +
          `Orcamento/GetTipoFluxoOrcamento/${this.OrcamentoSelecionado}`,
      })
        .then((response) => {
          this.tipoFluxoOrcamento = response.data.data.tipoFluxoOrcamento;
          if (this.tipoFluxoOrcamento === 0) {
            this.temImagem = false;
          } else {
            this.temImagem = true;
          }
        })
        .catch(() => {});
    },

    InformacoesOrcamentoQuantidadeByOrcamentoId() {
      this.$isLoading(true)
      this.axios({
        method: "get",
        url:
          process.env.VUE_APP_WEB_API +
          `OrcamentoQuantidade/GetOrcamentoQuantidadeByOrcamentoId/${this.OrcamentoSelecionado}`,
      })
        .then((response) => {
          onchange;
          this.OrcaQuantidade = response.data.data;
          this.OrcaQuantidadeDiaCarregamento = response.data.data;
        })
        .finally(()=> {
          this.$isLoading(false)
        })
    },

    GridNomeProduto1() {
      return this.temImagem ? "3 / 1 / 4 / 2" : "1 / 1 / 2 / 2";
    },
    GridQtdData1() {
      return this.temImagem ? "4 / 1 / 5 / 2" : "2 / 1 / 3 / 2";
    },
    GridAmostraRef1() {
      return this.temImagem ? "5 / 1 / 6 / 2" : "3 / 1 / 4 / 2";
    },
    
    GridNomeProduto2() {
      return this.temImagem ? "1 / 2 / 2 / 3" : "1 / 1 / 2 / 2";
    },
    GridQtdData2() {
      return this.temImagem ? "2 / 2 / 3 / 3 " : "1 / 2 / 2 / 3";
    },
    GridAmostraRef2() {
      return this.temImagem ? "3 / 1 / 4 / 3" : "2 / 1 / 3 / 3";
    },

    GridNomeProduto3() {
      return this.temImagem ? "1 / 3 / 2 / 5" : "1 / 1 / 2 / 3";
    },
    GridQtdData3() {
      return this.temImagem ? "1 / 5 / 2 / 7" : "1 / 3 / 2 / 5";
    },
    GridAmostraRef3() {
      return this.temImagem ? "3 / 1 / 4 / 7" : "1 / 5 / 2 / 7";
    },

    GridNomeProduto4() {
      return this.temImagem ? "1 / 3 / 2 / 5" : "1 / 1 / 2 / 3";
    },
    GridQtdData4() {
      return this.temImagem ? "1 / 5 / 2 / 7" : "1 / 3 / 2 / 5";
    },
    GridAmostraRef4() {
      return this.temImagem ? "1 / 7 / 2 / 9" : "1 / 5 / 2 / 7";
    },

    RetornaQtdLinha1() {
      return this.temImagem ? "5" : "3"
    },
    RetornaQtdLinha2() {
      return this.temImagem ? "3" : "2"
    },
    RetornaQtdLinha4() {
      return this.temImagem ? "2" : "1"
    },

    RetornaQtdColuna() {
      return this.temImagem ? "8" : "10"
    },

    getCliente() {
      this.axios({
        method: "get",
        url:
          process.env.VUE_APP_WEB_API +
          `Cliente/GetClienteByOrcamento/${this.OrcamentoSelecionado}`,
      })
        .then((response) => {
          this.cnpj = response.data.data.cnpj;
          this.cep = response.data.data.cep;
          this.codigoUsuario = response.data.data.codigo;
          this.incentivoFiscal = response.data.data.incentivo;
          this.nomeCidade = response.data.data.nomeCidade;
          this.nomeContato = response.data.data.nomeContato;
          this.numeroRamal = response.data.data.numeroRamal;
          this.numeroSuframa = response.data.data.numeroSuframa;
          this.numeroTelefone = response.data.data.numeroTelefone;
          this.razaoSocial = response.data.data.razaoSocial;
          this.segmentoFormat = response.data.data.clienteTipoTexto;
          this.siglaEstado = response.data.data.siglaEstado;
          this.numeroCelular = response.data.data.numeroCelular;

          if (response.data.data.icms === true) {
            this.icms = "ICMS   ";
          } else {
            this.icms = "";
          }

          if (response.data.data.ipi === true) {
            this.ipi = "IPI   ";
          } else {
            this.ipi = "";
          }

          if (response.data.data.piscofins === true) {
            this.piscofins = "PisCofins";
          } else {
            this.piscofins = "";
          }

          this.getLoteFrete();
        })
        .catch(() => {});
    },

    getLoteFrete() {
      this.axios({
        method: "get",
        url:
          process.env.VUE_APP_WEB_API +
          `LoteFrete/GetLoteFreteFinalByOrcamentoId/${this.OrcamentoSelecionado}`,
      })
        .then((response) => {
          this.freteEnum = response.data.data.indicadorDeTipoFreteText;
          this.getSequencia = response.data.data.getSequencia;
          this.indicadorDeTipoFrete = response.data.data.indicadorDeTipoFrete;
          this.tipoFreteEnum = response.data.data.tipoFreteEnumTexto;
          this.informacaoLoteText = response.data.data.informacaoLoteText;
          this.riscoFacaPrototipo = response.data.data.riscoFacaPrototipo;
          this.getComponentes();
        })
        .catch(() => {});
    },

    getLogOrcamentoPendenteInformacao() {
      this.axios({
        method: "get",
        url:
          process.env.VUE_APP_WEB_API +
          `Componente/getLogOrcamentoPendenteInformacao/`,
      }).then(() => {

      })
    },

    getComponentes() {
      this.axios({
        method: "get",
        url:
          process.env.VUE_APP_WEB_API +
          `Componente/GetComponentesByOrcamentoId/${this.OrcamentoSelecionado}`,
      })
        .then((response) => {
          if(response.data.data == [])
          {
            this.contemComponentes = false
          }
          else{
            this.componentesLista = response.data.data;
            this.contemComponentes = true
            this.embalagensEspecificas()
          }

          this.componentesLista.forEach((r)=>{
            r.ColunaMedidas = `${r.numeroComprimento} x ${r.numeroLargura} x  ${r.numeroAltura} x ${r.numeroAlturaTampa}`
            return this.ColunaMedidas = r.ColunaMedidas
            })

          this.getParametros();
        })
        .catch(() => {});
    },

    InformacoesOrcamentoComponenteByOrcamentoId() {
      this.axios({
        method: "get",
        url:
          process.env.VUE_APP_WEB_API +
          `OrcamentoComponente/GetOrcamentoComponenteProdutoNovoByOrcamentoId/${this.OrcamentoSelecionado}`,
      })
        .then((response) => {
          this.InformacaoOrcamentoComponenteArray = response.data.data;

        })
        .catch(() => {});
    },

    getInfosBasicas() {
      this.axios({
        method: "get",
        url:
          process.env.VUE_APP_WEB_API +
          `Orcamento/GetInfosBasicasByOrcamentoId/${this.OrcamentoSelecionado}`,
      })
        .then((response) => {
          this.nomeProduto = response.data.data.nomeProduto;
          this.getParametros();
        })
        .catch(() => {});
    },

    getParametros() {
      this.axios({
        method: "get",
        url:
          process.env.VUE_APP_WEB_API +
          `Orcamento/GetParametroByOrcamentoId/${this.OrcamentoSelecionado}`,
      })
        .then((response) => {
          this.dataDigitacaoFormatadaConsulta =
            response.data.data.dataDigitacaoFormatada;
          this.nomeEmpresa = response.data.data.nomeEmpresa;
          this.nomeRepresentante = response.data.data.nomeRepresentante;
          this.statusText = response.data.data.orcamentoSituacaoEnum;
          this.statusEnum = response.data.data.status;
          this.statuscor = response.data.data.corStatus;
          this.dataAlteracao = response.data.data.dataAlteracaoFormatada;
          this.numeroSolicitacao = response.data.data.codigoExterno;
          this.dataEHora = response.data.data.dataEHoraJuntasFormatado;
          this.prazoMaximo = response.data.data.prazoMaximo;
          this.gramatura  = response.data.data.gramatura;
          this.getDemaisCarac();
        })
        .catch(() => {});
    },

    entrarPopUp() {
      if (this.statusEnum == 11) {
        this.popupRejeitado = true;
      }
    },

    getLog() {
      this.axios({
        method: "get",
        url:
          process.env.VUE_APP_WEB_API +
          `Orcamento/GetLog/${this.OrcamentoSelecionado}`,
      }).then((response) => {

      })
    },

    getDemaisCarac() {
      this.axios({
        method: "get",
        url:
          process.env.VUE_APP_WEB_API +
          `Orcamento/GetDemaisCaracByOrcamentoId/${this.OrcamentoSelecionado}`,
      }).then((response) => {
        this.OrcamentoGeraisFsc = response.data.data.fsc;
        this.OrcamentoGeraisLegislacao = response.data.data.legislacao;
        this.OrcamentoDescricaoSequencia =
          response.data.data.descricaoSequencia;

        this.OrcamentoCritica1 = response.data.data.critica1;
        this.OrcamentoCritica2 = response.data.data.critica2;
        this.OrcamentoCritica3 = response.data.data.critica3;
        this.OrcamentoCritica4 = response.data.data.critica4;
        this.OrcamentoCritica5 = response.data.data.critica5;
        this.observacoesGerais = response.data.data.observacoesGerais;

        this.OrcamentoEmbalagemFilme =
          response.data.data.embalagemEspecificaFilmeEncolhivel;
        this.OrcamentoEmbalagemCaixaColetiva =
          response.data.data.embalagemEspecificaCaixaColetiva;
        this.OrcamentoEmbalagemPalete =
          response.data.data.embalagemEspecificaPalete;
        this.OrcamentoEmbalagemOutros = response.data.data.embalagemOutros;
        this.OrcamentoEmbalagemDescOutros =
          response.data.data.descricaoOutrasEmbalagens;

        this.OrcamentoAmostra = response.data.data.amostra;
        this.OrcamentoAmostraEspTecnica =
          response.data.data.amostraEspecificacaoTecnica;
        this.OrcamentoAmostraOutros = response.data.data.outros;
        this.OrcamentoAmostraDescOutros =
          response.data.data.descricaoOutrosMateriais;

        this.DescricaoLote = response.data.data.lote;

        this.motivoBaixaText = response.data.data.motivoBaixaText;
        this.nomeclienteBaixa = response.data.data.nomeclienteBaixa;
        this.observacoesRetorno = response.data.data.observacoesRetorno

        this.chamarImagem();
      });
    },

    observacao() {
      this.axios({
        method: "get",
        url:
          process.env.VUE_APP_WEB_API +
          `OrcamentoQuantidade/GetObservacaoByOrcamentoId/${this.OrcamentoSelecionado}`,
      })
        .then((response) => {
          onchange;
          this.InformacaoObservacao = response.data.data.observacao;
        })
        .catch(() => {});
    },

    GetOrcamentoQuantidadeIdeal(){
      OrcamentoController.GetOrcamentoQuantidadeIdeal(this.$route.params.id).requisicao
      .then(res => {
        this.quantidadePrecoArray = res.data.data
      });
    },

    GetFormaPagamentoOrcamento(){
      OrcamentoController.GetFormaPagamentoOrcamento(this.$route.params.id).requisicao
      .then(res => {
        this.porcentagemFinanceira = res.data.data.porcentagemFinanceira;
        this.formaPagamento = res.data.data.formaPagamento;
      })
    },

    async chamarImagem() {
      this.images = await this.galleriaService.getImage(
        this.OrcamentoSelecionado,
        this.images
      );
      this.executaTermino();
    },

    embalagensEspecificas(){
      this.componentesLista.forEach((r)=>{
        r.embalagens = []
        r.embalagemEspecificaFilmeEncolhivel == true ? r.embalagens.push('Filme encolhível - ' + `${r.quantidadeFilmeEncolhivel}`) : ''
        r.embalagemEspecificaCaixaColetiva == true  ? r.embalagens.push('Caixa Coletiva - ' + `${r.quantidadeCaixaColetiva}`) : ''
        r.embalagemEspecificaPalete == true  ? r.embalagens.push('Palete - ' + `${r.quantidadePalete}`) : ''
        r.embalagemEspecificaPapelEmbrulho == true  ? r.embalagens.push('Papel Embrulho - ' + `${r.quantidadeFilmeEncolhivel}`) : ''
  })
  },
  },

  computed: {},
});
